import React from 'react';
import { Modal } from "react-bootstrap";
import AddUser from '../../Pages/Usuario/AltaUsuario';

const UserFormModal = ({showModal, handleCloseModal}) => {
  return (
   <Modal show={showModal} onHide={handleCloseModal} size="xl">
  <Modal.Header closeButton>
    <Modal.Title>Agregar nuevo usuario</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <AddUser isModal={true} handleCloseModal={handleCloseModal} />
  </Modal.Body>
</Modal>

  )
}

export default UserFormModal;